import { Table } from "../Table/Table";
import { useMemo, useState } from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import _ from "lodash";

export const PrintSizesTable = ({ items, handleUpdate, handleDelete, t }) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationModalData, setConfirmationModalData] = useState({
    text: "",
    headerText: "",
    icon: "",
  });
  const [confirmationModalOnSuccess, setConfimationModalOnSuccess] = useState(() => {
    return;
  });
  const [confirmationModalDataForOnSuccess, setConfimationModalDataForOnSuccess] = useState({});

  /* Filter and Cell functions use the function-syntax here to go around an eslint warning:
    "Component definition is missing display name. eslint(react/display-name)"
  */
  const columns = useMemo(
    () => [
      {
        Header: t("name"),
        accessor: "name",
      },
      {
        id: "updateDeleteRow",
        maxWidth: 10,
        Cell: function updateDeleteRow({ row }) {
          return (
            <>
              <Popup
                content={t("print_size_update")}
                trigger={
                  <Button basic icon size="mini" onClick={() => handleUpdate(row.original)}>
                    <Icon name="edit outline" />
                  </Button>
                }
              />
              <Popup
                content={t("print_size_delete")}
                trigger={
                  <Button
                    basic
                    icon
                    size="mini"
                    onClick={() => {
                      setConfirmationModalData({
                        text: t("print_size_delete_modal_text"),
                        headerText: t("print_size_delete"),
                        icon: "delete",
                      });
                      setConfimationModalOnSuccess(() => handleDelete);
                      setConfimationModalDataForOnSuccess(row.original);
                      setConfirmationModalOpen(true);
                    }}
                  >
                    <Icon name="delete" />
                  </Button>
                }
              />
            </>
          );
        },
      },
    ],
    [handleUpdate, handleDelete, t]
  );

  const sortedItems = useMemo(() => (items ? _.sortBy(items, "name") : []), [items]);

  return (
    <>
      <Table columns={columns} data={sortedItems} t={t} />
      <ConfirmationModal
        data={confirmationModalData}
        open={confirmationModalOpen}
        setOpen={setConfirmationModalOpen}
        onSuccess={confirmationModalOnSuccess}
        dataForOnSuccess={confirmationModalDataForOnSuccess}
      />
    </>
  );
};
